import { ADD_LMS_GROUPS_FAIL, ADD_LMS_GROUPS_REQUEST, ADD_LMS_GROUPS_SUCCESS } from '../reducers/getLMSInfo';
import { GroupAPI } from '@brg/api';
import { computeGroup } from '../utilites/compute/ComputedGroup';
export function getGroups(teamId) {
    return function (dispatch) {
        dispatch({
            type: ADD_LMS_GROUPS_REQUEST,
            payload: {}
        });
        GroupAPI.GetByTeamId({ teamId: teamId })
            .then(function (r) {
            return r.json();
        })
            .then(function (r) {
            var _a;
            if (r) {
                dispatch({
                    type: ADD_LMS_GROUPS_SUCCESS,
                    payload: {
                        groups: (_a = (r || [])) === null || _a === void 0 ? void 0 : _a.map(function (g) { return computeGroup(g); })
                    }
                });
            }
        })
            .catch(function (e) {
            dispatch({
                type: ADD_LMS_GROUPS_FAIL,
                payload: {}
            });
        });
    };
}
//# sourceMappingURL=getGroups.js.mapimport { ADD_LMS_GROUPS_FAIL, ADD_LMS_GROUPS_REQUEST, ADD_LMS_GROUPS_SUCCESS } from '../reducers/getLMSInfo';
import { GroupAPI } from '@brg/api';
import { computeGroup } from '../utilites/compute/ComputedGroup';
export function getGroups(teamId) {
    return function (dispatch) {
        dispatch({
            type: ADD_LMS_GROUPS_REQUEST,
            payload: {}
        });
        GroupAPI.GetByTeamId({ teamId: teamId })
            .then(function (r) {
            return r.json();
        })
            .then(function (r) {
            var _a;
            if (r) {
                dispatch({
                    type: ADD_LMS_GROUPS_SUCCESS,
                    payload: {
                        groups: (_a = (r || [])) === null || _a === void 0 ? void 0 : _a.map(function (g) { return computeGroup(g); })
                    }
                });
            }
        })
            .catch(function (e) {
            dispatch({
                type: ADD_LMS_GROUPS_FAIL,
                payload: {}
            });
        });
    };
}
//# sourceMappingURL=getGroups.js.map